var recruiterContactButtonTemplate =
  '<a ' +
    'ng-href="{{ ::vm.link }}" ' +
    'target="{{ ::vm.openInNewTab ? \'_blank\' : \'_self\'}}" ' +
    'class="actions-belt-item" ' +
    'uib-tooltip="{{vm.title}}" ' +
    'tooltip-popup-delay="750">' +
      '<i class="fal icon-envelope" ng-class="{\'orange\' : vm.recipientContacted}"></i>' +
      '<i class="fal icon-check overlapping-icon orange" ng-if="vm.recipientContacted"></i>' +
    '<ng-transclude></ng-transclude>' +
  '</a>';

angular.module('components.recruiterContactButton', [])
  .component('recruiterContactButton', {
    template: recruiterContactButtonTemplate,
    bindings: {
      consultantId: '<',
      link: '<',
      openInNewTab: '@',
      recipientsContacted: '<'
    },
    controller: [
      '$window',
      'RoutesService',
      function RecruiterContactButtonController($window, Routes) {
        var that = this;

        that.$onInit = function() {
          if(that.consultantId) {
            that.link = Routes.new_message_path({
              recipient_ids: [that.consultantId],
              return_to: $window.location.href
            });
          }
        };

        that.$onChanges = function() {
          that.title = 'Contact';
          that.recipientContacted = false;
          if (!that.recipientsContacted){
            return;
          }
          that.recipientsContacted.forEach(function(element) {
            if (element.consultant_id === that.consultantId) {
              var dateString = devex.util.formatDate(element.last_contacted);
              that.title = 'Last contacted on ' + dateString;
              that.recipientContacted = true;
            }
          });
        };
      }
    ],
    controllerAs: 'vm',
    transclude: true
  });
